<template>
  <div>
    <el-dialog
        :title="'Tạo cấu hình'"
        :visible.sync="isAddOneKidsConfigDialog"
        width="800px"
        :before-close="handleClose"
        top="5vh"
        :close="handleClose"
    >
      <el-form
          :model="formData"
          :rules="rules" ref="formData"
          label-position="left"
          label-width="150px">
        <el-form-item label="Tên cấu hình" prop="configName">
          <el-input v-model="formData.configName"></el-input>
        </el-form-item>
        <el-form-item label="Tên biến" prop="variableName">
          <el-input v-model="formData.variableName"></el-input>
        </el-form-item>
        <el-form-item label="Mô tả chức năng" prop="description">
          <el-input v-model="formData.description" type="textarea" :rows="4"></el-input>
        </el-form-item>
        <el-form-item label="Chọn chức năng" prop="type">
          <el-select
              style="width: 100%"
              filterable
              clearable
              v-model="formData.type"
              placeholder="Chọn chức năng"
          >
            <el-option
                v-for="item in configTypeList"
                :key="item.id"
                :value="item.value"
                :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Chọn kiểu dữ liệu" prop="dataType">
          <el-select
              style="width: 100%"
              filterable
              clearable
              v-model="formData.dataType"
              placeholder="Chọn kiểu dữ liệu"
          >
            <el-option
                v-for="item in dataTypeList"
                :key="item.id"
                :value="item.value"
                :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Giá trị" prop="value">
          <el-input v-model="formData.value"></el-input>
        </el-form-item>
      </el-form>
      <div class="buttons">
        <el-button
            :loading="loading"
            size="medium"
            type="success"
            style="margin-right: 10px"
            @click="handleUpload()"
        >
          Lưu
        </el-button>
        <el-button size="medium" type="danger" @click="handleClose">
          <i class="el-icon-circle-close"/> Đóng
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import oneKidsConfigService from "@/services/AdminService/OneKidsConfigService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "AddOneKidsConfigDialog",
  data() {
    return {
      formData: {
        configName: "",
        variableName: "",
        description: "",
        dataType: "",
        value: "",
        type: ""
      },
      loading: false,
      configTypeList: [
        {id: 1, value: "CHAT", label: "OneChat"},
        {id: 2, value: "HOME", label: "Màn home"},
        {id: 3, value: "ALBUM", label: "Album"},
        {id: 4, value: "RECOGNITION", label: "Nhận diện AI"},
        {id: 5, value: "ONLINE_PAYMENT", label: "Thanh toán trực tuyến"},
        {id: 6, value: "OTHER", label: "Khác"},
      ],
      dataTypeList: [
        {id: 1, value: "STRING", label: "STRING"},
        {id: 2, value: "INT", label: "INT"},
        {id: 3, value: "BOOLEAN", label: "BOOLEAN"},
        {id: 4, value: "FLOAT", label: "FLOAT"},
        {id: 5, value: "DATE", label: "DATE"},
        {id: 6, value: "JSON", label: "JSON"},
      ],
      rules: {
        configName: [
          {required: true, message: 'Không được để trống', trigger: 'change'}
        ],
        variableName: [
          {required: true, message: 'Không được để trống', trigger: 'change'}
        ],
        description: [
          {required: true, message: 'Không được để trống', trigger: 'change'}
        ],
        dataType: [
          {required: true, message: 'Không được để trống', trigger: 'change'}
        ],
        value: [
          {required: true, message: 'Không được để trống', trigger: 'change'}
        ],
        type: [
          {required: true, message: 'Không được để trống', trigger: 'change'}
        ],
      }
    }
  },
  props: {
    isAddOneKidsConfigDialog: {
      type: Boolean,
      default: false
    },
  },

  methods: {
    handleClose() {
      this.$refs['formData'].resetFields();
      this.$emit("close");
    },
    handleUpload() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.loading = true;
          oneKidsConfigService.createOneKidsConfig(this.formData).then((res) => {
            if (res.data) {
              NotifyMessage.leftCornerNotificationSuccess("Tạo mới cấu hình thành công")
            } else {
              NotifyMessage.leftCornerNotificationError("Tạo mới cầu hình thất bại")
            }
            this.loading = false;
            this.handleClose();
          }).catch((err) => {
            this.loading = false;
            NotifyMessage.leftCornerNotificationError(err.response.data.message)
          })
        }
      });
    }
  }

}
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  justify-content: right;
  text-align: right;
  margin-top: 10px;
}
</style>